import { Monitor, Moon, Sun } from 'lucide-react';
import { useI18n } from '@/lib/i18n';
import { useTheme, type ThemePreference } from '@/lib/theme';
import { IconButton } from '@/components/ui/Button';
import { Menu } from '@/components/ui/Menu';

const icons = { light: Sun, dark: Moon, system: Monitor } as const;

/** Light / dark / system chooser; the choice is persisted and applied before first paint. */
export function ThemeToggle({ className, onDark }: { className?: string; onDark?: boolean }) {
  const { preference, setPreference, resolved } = useTheme();
  const { t } = useI18n();
  const Icon = resolved === 'dark' ? Moon : Sun;
  const entry = (value: ThemePreference, label: string) => {
    const I = icons[value];
    return { id: value, label, icon: <I />, checked: preference === value, onSelect: () => setPreference(value) };
  };
  return (
    <Menu
      label={t('shell.theme')}
      items={[entry('light', t('theme.light')), entry('dark', t('theme.dark')), entry('system', t('theme.system'))]}
      trigger={<IconButton label={`${t('shell.theme')}: ${t(`theme.${preference}`)}`} icon={<Icon className="h-[1.125rem] w-[1.125rem]" aria-hidden="true" />} className={onDark ? 'text-navy-200 hover:bg-white/10 hover:text-white' : className} />}
    />
  );
}
